import React, { useEffect, ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import LogRocket from 'logrocket';

import { queryStrings } from '@trqk/resolvers';
import { shouldEnableLogRocket } from '@trqk/utils';

const { GET_SESSION_CURRENT_USER } = queryStrings;

interface IdentifyUserProps {
    children: ReactNode;
}

const enableLogRocket = shouldEnableLogRocket();

/**
 * Calls `LogRocket.identify` to uniquely identify the current user.
 * @param props - {@link IdentifyUserProps}
 * @returns JSX
 */
export const IdentifyUser = ({ children }: IdentifyUserProps): JSX.Element => {
    const currentUserQuery = useQuery<{ session: Session }>(
        GET_SESSION_CURRENT_USER,
    );
    const userId = currentUserQuery?.data?.session?.currentUser?.id;
    const email = currentUserQuery?.data?.session?.currentUser?.email;
    const name = currentUserQuery?.data?.session?.currentUser?.name;

    useEffect(() => {
        if (enableLogRocket) {
            if (userId && (!email || !name)) {
                LogRocket.identify(userId);
            } else if (userId && email && name) {
                LogRocket.identify(userId, {
                    email,
                    name,
                });
            }
        }
    }, [userId, enableLogRocket]);

    return <>{children}</>;
};
